import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import "./css/Footer.css";

export default function Footer({ onQuoteClick }) {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      {/* Scroll to Top */}
      <button onClick={scrollToTop} className="scroll-to-top" aria-label="Scroll to top">
        <FontAwesomeIcon icon={faArrowUp} />
      </button>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="footer-container">
          {/* Left Column - Navigation */}
          <div className="footer-column">
            <h4 className="footer-heading">Navigate</h4>
            <nav className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/about">About</Link>
            </nav>
          </div>

          {/* Center Column - Brand */}
          <div className="footer-column footer-center">
            <Link to="/" className="footer-logo">
              <img src="/assets/logo.webp" alt="Enchanted Gardener" className="footer-logo-image" />
            </Link>
            <p className="footer-tagline">
              Transforming outdoor spaces into natural sanctuaries since 2007.
            </p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/p/Enchanted-Gardener-100063840151844/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="social-link"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href="https://www.instagram.com/enchantedgardener/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-link"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
            <button onClick={onQuoteClick} className="footer-cta">
              Request a Quote
            </button>
          </div>

          {/* Right Column - Contact */}
          <div className="footer-column footer-right">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-links">
              <a href="tel:6166820808">(616) 682-0808</a>
              <a href="mailto:info@enchanted-gardener.com">info@enchanted-gardener.com</a>
              <a
                href="https://www.google.com/maps/place/Enchanted+Gardeners+LLC/@42.956294,-85.435062,17z"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ada, Michigan
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">
            © {currentYear} Enchanted Gardener
          </p>
          <p className="footer-credit">
            Website by{" "}
            <a href="https://syncgr.com" target="_blank" rel="noopener noreferrer">
              Sync
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
